module.exports = __webpack_public_path__ + "img/21.74c5c07a.png";